<template>
  <b-card-actions action-collapse title="Liste des devis">
    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <!-- <label class="mr-1">Recherche</label> -->
            <b-form-input
              placeholder="Recherche"
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />
            <b-button
              variant="gradient-danger"
              class="btn-icon btn-delete-all"
              @click="deleteAllQuote()"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
            <b-button
              variant="gradient-success"
              class="btn-icon btn-delete-all"
              v-b-modal.modal-quote
            >
              <feather-icon icon="PlusIcon" />
            </b-button>
          </div>
        </b-form-group>
      </div>
    </div>

    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
                    ref="table-quote"

      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      :group-options="{
        enabled: true,
        headerPosition: 'top',
      }"
      theme="my-theme"
    >
      <template slot="table-header-row" slot-scope="headerProps">
        <span class="my-fancy-class">
          {{ headerProps.row.label }}
          <span class="btn-table-groupe">
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item @click="AddQuoteOffer(headerProps.row.id)">
                <feather-icon icon="PlusIcon" class="mr-50" />
                <span>Ajouter devis</span>
              </b-dropdown-item>
              <!-- <b-dropdown-item
                @click="
                  UpdateQuote(
                    headerProps.row.purchaseQuotation, headerProps.row.id
                  )
                "
              >
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Modifier</span>
              </b-dropdown-item> -->
              <b-dropdown-item @click="DeleteQuote(headerProps.row.id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Supprimer</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
      </template>
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>

              <b-dropdown-item
                @click="
                  previewQuote(props.row.purchaseQuotation, props.row._id)
                "
              >
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span>Consulter Devis</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-b-modal.modal-product
                @click="productQuote(props.row)"
              >
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span>Détails Produits</span>
              </b-dropdown-item>
              <b-dropdown-item @click="createCommand(props.row)">
                <feather-icon icon="FileTextIcon" class="mr-50" />
                <span>Créer commande</span>
              </b-dropdown-item>
              <b-dropdown-item @click="createInvoice(props.row)">
                <feather-icon icon="FilePlusIcon" class="mr-50" />
                <span>Créer facture</span>
              </b-dropdown-item>
              <b-dropdown-item
                @click="
                  UpdateQuote(props.row.purchaseQuotation, props.row._id, props)
                "
              >
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Modifier</span>
              </b-dropdown-item>
              <b-dropdown-item
                @click="
                  DeleteQuoteOffer(
                    props.row.purchaseQuotation,
                    props.row._id,
                    props
                  )
                "
              >
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Supprimer</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <span v-else-if="props.column.field == 'images'" class="dflex">
          <a
            v-for="(image, index) in props.row.images"
            :key="index"
            :href="imgFormat(image)"
            target="_blank"
            class="mlr10"
          >
            <b-img :src="imgFormat(image)" class="img-table"
          /></a>
        </span>
        <span v-else-if="props.column.field == 'description'">
          <p class="p-description">{{ props.row.description }}</p>
        </span>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Afficher 1 à </span>
            <b-form-select
              v-model="pageLength"
              :options="['5', '10', '15', '20']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> sur {{ props.total }} résultats </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

    <!-- update categorie -->
    <b-modal
      v-model="showUpdateCategorie"
      id="modal-categorie"
      cancel-variant="outline-secondary"
      ok-title="categorie"
      cancel-title="Close"
      centered
      title="Modifier catégorie"
    >
      <b-form>
        <b-form-group>
          <label for="label">Nom du catégorie:</label>
          <!-- <vue-autosuggest
            v-model="query"
            :suggestions="suggestions"
            :input-props="inputProps"
            :section-configs="sectionConfigs"
            :render-suggestion="renderSuggestion"
            :limit="10"
            @input="fetchResults"
          /> -->
           <v-select
                id="v-cat"
                v-model="categoriesValue"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                multiple
                label="title"
                :options="optionCategorie"
              />
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="warning"
            size="md"
            @click="
              UpdateCategoryLabel();
              show = false;
            "
          >
            Modifier
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- Add quote  -->
    <b-modal
      v-model="showAddQuote"
      id="modal-quote"
      cancel-variant="outline-secondary"
      ok-title="Login"
      cancel-title="Close"
      centered
      title="Ajouter devis"
    >
      <b-form>
        <b-form-group>
          <label for="label">Nom du catégorie:</label>
          <!-- <vue-autosuggest
            v-model="query"
            :suggestions="suggestions"
            :input-props="inputProps"
            :section-configs="sectionConfigs"
            :render-suggestion="renderSuggestion"
            :limit="10"
            @input="fetchResults"
          /> -->
           <v-select
                id="v-cat"
                v-model="categoriesValue"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="optionCategorie"
              />
        </b-form-group>
        <b-form-group>
          <label for="label">Nom du sous catégorie</label>
             <v-select
                id="v-souCat"
                v-model="subCategoriesValue"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="optionSubCategorie"
              />
          <!-- <b-form-input
            v-model="nameProduct"
            placeholder="Nom du produit"
            name="label"
          /> -->
        </b-form-group>
        <b-form-group>
          <label for="label">Devise:</label>
          <vue-autosuggest
            v-model="queryCurrency"
            :suggestions="suggestionsCurrency"
            :input-props="inputPropsCurrency"
            :section-configs="sectionConfigsCurrency"
            :render-suggestion="renderSuggestionCurrency"
            :limit="10"
            @input="fetchResultsCurrency"
          />
          <!-- <b-form-input id="label" type="text" placeholder="Devise" /> -->
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            size="md"
            @click="
              AddQuote();
              show = false;
            "
          >
            Ajouter
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- product details -->
    <b-modal
      v-model="show"
      id="modal-product"
      cancel-variant="outline-secondary"
      ok-title="Product"
      cancel-title="Close"
      centered
      size="lg"
      title="Liste des produits"
    >
      <vue-good-table
        :columns="columnsModal"
        :rows="rowModal"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLengthModal,
        }"
        theme="my-theme"
      >
        <template
          slot="table-row"
          slot-scope="propsModal"
          class="table-added-element"
        >
          <span
            v-if="propsModal.column.field == 'product.priceWithoutTaxes'"
            class="dflex"
          >
            {{ priceFormat(propsModal.row.discount) }}
          </span>
          <span v-else-if="propsModal.column.field == 'discount'" class="dflex">
            {{ propsModal.row.discount + "%" }}
          </span>
          <span
            v-else-if="propsModal.column.field == 'valueAddedTax'"
            class="dflex"
          >
            {{ propsModal.row.valueAddedTax + "%" }}
          </span>
          <span v-else>
            {{ propsModal.formattedRow[propsModal.column.field] }}
          </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Afficher 1 à </span>
              <b-form-select
                v-model="pageLengthModal"
                :options="['3', '5', '10']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> sur {{ props.total }} résultats </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLengthModal"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="danger"
            size="md"
            @click="show = false"
          >
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-card-actions>
</template>

<script>
import { currency } from "@/utils/data.js";
import vSelect from "vue-select";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BRow,
  BCol,
  BImg,
  BModal,
  VBModal,
  BForm,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BCardText,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";
import Ripple from "vue-ripple-directive";
import { VueAutosuggest } from "vue-autosuggest";

export default {
  components: {
  vSelect,
    BCardText,
    VueAutosuggest,
    BDropdown,
    BDropdownItem,
    BTooltip,
    BModal,
    VBModal,
    BForm,
    BImg,
    BButton,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      show: false,
      showUpdateCategorie: false,
      showAddQuote: false,
      pageLength: 5,
      pageLengthModal: 5,
      dir: false,
      columnsModal: [
        {
          label: "Label",
          field: "product.label",
          filterOptions: {
            enabled: true,
            placeholder: "Label",
          },
        },
        {
          label: "Quantité",
          field: "quantity",
          filterOptions: {
            enabled: true,
            placeholder: "Quantié",
          },
        },
        {
          label: "Prix sans tax",
          field: "product.priceWithoutTaxes",
          filterOptions: {
            enabled: true,
            placeholder: "Prix sans tax",
          },
        },
        {
          label: "Remise",
          field: "discount",
          filterOptions: {
            enabled: true,
            placeholder: "Remise",
          },
        },
        {
          label: "Tax",
          field: "valueAddedTax",
          filterOptions: {
            enabled: true,
            placeholder: "Tax",
          },
        },
      ],
      columns: [
            {
          label: "Action",
          field: "action",
          sortable: false,
        },
        {
          label: "Code",
          field: "code",
          filterOptions: {
            enabled: true,
            placeholder: "Code",
          },
        },
        {
          label: "État",
          field: "status",
          filterOptions: {
            enabled: true,
            placeholder: "État",
          },
        },
        {
          label: "Fournisseur",
          field: "supplier",
          formatFn: this.supplierFormat,
          filterOptions: {
            enabled: true,
            placeholder: "Fournisseur",
          },
        },
        {
          label: "Entrepôt",
          field: "warehouse",
          filterOptions: {
            enabled: true,
            placeholder: "Entrepôt",
          },
        },
        {
          label: "Date",
          field: "date",
          formatFn: this.dateFormat,
          filterOptions: {
            enabled: true,
            placeholder: "Date",
          },
        },
        {
          label: "Description",
          field: "description",
          filterOptions: {
            enabled: true,
            placeholder: "Description",
          },
        },

        {
          label: "Timbre",
          field: "stampPrice",

          filterOptions: {
            enabled: true,
            placeholder: "Timbre",
          },
        },
        {
          label: "Tax (%)",
          field: "valueAddedTax",
          filterOptions: {
            enabled: true,
            placeholder: "Tax",
          },
        },

        {
          label: "Remise (%)",
          field: "totalDiscount",
          filterOptions: {
            enabled: true,
            placeholder: "Remise",
          },
        },
        {
          label: "Totale TTC",
          field: "allTaxesIncluded",
          filterOptions: {
            enabled: true,
            placeholder: "Totale",
          },
        },
        {
          label: "Date d'insertion",
          field: "createdAt",
          filterOptions: {
            enabled: true,
            placeholder: "Date d'insertion",
          },
          formatFn: this.dateFormat,
        },
        {
          label: "Agent de saisie",
          field: "createdBy",
          filterOptions: {
            enabled: true,
            placeholder: "Agent de saisie",
          },
          formatFn: this.createdByFormat,
        },
        {
          label: "Date d'insertion",
          field: "createdAt",
          filterOptions: {
            enabled: true,
            placeholder: "Date d'insertion",
          },
          formatFn: this.dateFormat,
        },
        {
          label: "Images",
          field: "images",
          sortable: false,
          width: "150px",
          // html: true,
        },
    
      ],
      optionCategorie:[],
      optionSubCategorie:[],
      subCategoriesValue:'',
      categoriesValue:'',
      rows: [],
      rowModal: [],
      searchTerm: "",
      // modal add quotes (input)
     // datasuggest: [],
      //query: "",
     // suggestions: [],
     // selected: null,
      // inputProps: {
      //   id: "autosuggest__input",
      //   class: "form-control",
      //   placeholder: "Nom du catégorie",
      // },
      // sectionConfigs: {
      //   Categorie: {
      //     limit: 6,
      //     label: "Categorie",
      //     onSelected: (selected) => {
      //       this.selected = selected.item;
      //     },
      //   },
      // },

      datasuggestCurrency: [],
      queryCurrency: "",
      suggestionsCurrency: [],
      selectedCurrency: null,
      inputPropsCurrency: {
        id: "autosuggest__input",
        class: "form-control",
        placeholder: "Nom du pays ou devise",
      },
      sectionConfigsCurrency: {
        Currency: {
          limit: 6,
          label: "Devise",
          onSelected: (selected) => {
            this.selectedCurrency = selected.item;
          },
        },
      },
      // end  modal add quotes (input)
    };
  },
  async created() {
    await this.getAllDataQuote();
    this.getAllDataCategory();
  },
  methods: {
    advanceSearch(val) {
      this.searchTerm = val;
    },
    // Start To => utils************************************************
    priceFormat(price) {
      if (price) {
        return Number.parseFloat(price).toFixed(3);
      }
    },
    imgFormat: function (value) {
      if (value) {
        return (
          "https://res.cloudinary.com/dmdd546ps/image/upload/v1615691410/" +
          value +
          ".png"
        );
      }
    },
    //date format
    dateFormat: function (value) {
      return new Date(value).toLocaleString();
    },
    //category format
    categoryFormat: function (value) {
      return value.label;
    },
    // table Format
    tableFormat: function (value) {
      const table = value.map((element) => {
        return element.label;
      });
      return table.toString();
    },
    // name agent de saisie
    createdByFormat: function (value) {
      return value.firstName + " " + value.lastName;
    },
    supplierFormat: function (value) {
      return value.firstName + " " + value.lastName;
    },
    // End To => utils************************************************

    // Serach catégorie
    // fetchResults(text) {
    //   const { query } = this;
    //   if (query) {
    //     this.suggestions = [];
    //   }
    //   if (text === "" || text === undefined) {
    //     return;
    //   }
    //   const filteredCategory = this.datasuggest[0].Category.filter(
    //     (item) => item.name.toLowerCase().indexOf(text.toLowerCase()) > -1
    //   ).slice(0, this.limit);
    //   this.suggestions.push({
    //     name: "Categorie",
    //     data: filteredCategory,
    //   });
    // },
    // renderSuggestion(suggestion) {
    //   return (
    //     <div class="d-flex align-items-center">
    //       <div class="detail">
    //         <b-card-text class="mb-0">{suggestion.item.name}</b-card-text>
    //       </div>
    //     </div>
    //   );
    // },

    fetchResultsCurrency(text) {
      const { queryCurrency } = this;
      if (queryCurrency) {
        this.suggestionsCurrency = [];
      }
      if (text === "" || text === undefined) {
        return;
      }
      const filteredCurrency = currency
        .filter(
          (item) =>
            (item.name + item.currencies[0].code)
              .toLowerCase()
              .indexOf(text.toLowerCase()) > -1
        )
        .slice(0, this.limit);
      this.suggestionsCurrency.push({
        name: "Currency",
        data: filteredCurrency,
      });
    },
    renderSuggestionCurrency(suggestion) {
      return (
        <div class="d-flex align-items-center">
          <b-avatar src={suggestion.item.flag} class="mr-50"></b-avatar>
          <div class="detail">
            <b-card-text class="mb-0">{suggestion.item.name}</b-card-text>
            <small class="text-muted">
              {suggestion.item.currencies[0].code}
            </small>
          </div>
        </div>
      );
    },

    // update category
    UpdateCategoryLabel() {
      axios
        .put(
          "https://management-projects.herokuapp.com/api/categories/" +
            this.idUpdatecategory,
          this.updatecategory
        )
        .then((response) => {
          console.log("supprimer category", response);
          this.getAllDataCategory();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Catégorie bien modifié`,
              icon: "UserIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Erreur lors de la modification`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
          console.log(this.errorMessage);
        });
    },
    // get catégorie
    getAllDataCategory() {
      // axios
      //   .get("https://management-projects.herokuapp.com/api/categories")
      //   .then((response) => {
      //     var newObjSelect = [
      //       {
      //         Category: [],
      //       },
      //     ];
      //     newObjSelect[0].Category = response.data.map((element) => {
      //       var newObj = {
      //         id: element._id,
      //         name: element.label,
      //       };
      //       return newObj;
      //     });
      //     this.datasuggest = newObjSelect;
      //   })
      //   .catch((error) => {
      //     this.errorMessage = error.message;
      //   });
      axios
      .get("https://management-projects.herokuapp.com/api/categories")
      .then((response) => {
        response.data.forEach((element) => {
          // this.subCategories.push(element.subCategories);
          this.optionCategorie.push({ title: element.label, id: element._id });
          element.subCategories.forEach((subElement) => {
            this.optionSubCategorie.push({
              title: subElement.label,
              id: subElement._id,
            });
          });
        });
      })
      .catch((error) => {
        this.errorMessage = error.message;
      });
    },
    AddQuote() {
      console.log(this.categoriesValue, this.subCategoriesValue);
      var routerLink =
        "/shop/quote/add-quote?currency=" +
        this.selectedCurrency.currencies[0].code +
        "&categorie=" +
        this.categoriesValue.id +
        "&subCategorie=" +
        this.subCategoriesValue.id;
      this.$router.replace(routerLink);
    },
    getAllDataQuote() {
      if (this.$router.history.current.query.suppliers) {
        const response = axios
          .get(
            "https://management-projects.herokuapp.com/api/purchase-quotations?supplier=" +
              this.$router.history.current.query.supplier
          )
          .then((response) => {
            console.log(response);
            let rows = response.data;
            rows = rows.map((row) => {
              return {
                mode: "span",
                label: row.category.label,
                html: false,
                children: row.offers,
              };
            });
            this.rows = rows;
          })
          .catch((error) => {
            this.errorMessage = error.message;
          });
      } else {
        const response = axios
          .get(
            "https://management-projects.herokuapp.com/api/purchase-quotations"
          )
          .then((response) => {
            console.log(response);
            let rows = response.data;
            rows = rows.map((row) => {
              return {
                id: row._id,
                mode: "span",
                label: row.category.label,
                html: false,
                children: row.offers,
              };
            });
            console.log("rows", rows);
            this.rows = rows;
          })
          .catch((error) => {
            this.errorMessage = error.message;
          });
      }
    },
      deleteAllQuote() {
      var deleteIds = [];
      this.$refs["table-quote"].selectedRows.forEach((element) => {
        deleteIds.push(element._id);
      });
      axios
        .delete(
          `https://management-projects.herokuapp.com/api/purchase-quotations?ids=${deleteIds.join(
            ","
          )}&deletedBy=${JSON.parse(localStorage.getItem("userData"))._id}`
        )
        .then((response) => {
          this.getAllDataQuote();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Devis bien supprimé`,
              icon: "UserIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Erreur lors de la suppression`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
          console.log(this.errorMessage);
        });
    },
    DeleteQuote(id) {
      this.$swal({
        title: "vous voulez vraiment supprimer cette Devis ?",
        text: "Vous ne pourrez pas annuler cela!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmer !",
        cancelButtonText: "Annuler !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          var payload = {
            deletedBy: JSON.parse(localStorage.getItem("userData"))._id,
          };
          axios
            .delete(
              `https://management-projects.herokuapp.com/api/purchase-quotations?ids=${id}&deletedBy=${
                JSON.parse(localStorage.getItem("userData"))._id
              }`
            )
            .then((response) => {
              this.getAllDataQuote();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Devis bien supprimé`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Erreur lors de la suppression`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
              console.log(this.errorMessage);
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action annulée",
            icon: "error",
            confirmButtonText: "Fermer !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    DeleteQuoteOffer(quote, offer, props) {
      console.log(props);
      console.log(quote);
      console.log(offer);
      axios
        .put(
          `https://management-projects.herokuapp.com/api/purchase-quotations/${quote}`,
          {
            offers: {
              toDelete: [offer],
            },
            _id: quote,
            updatedBy: JSON.parse(localStorage.getItem("userData"))._id,
          }
        )
        .then((response) => {
          this.getAllDataQuote();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Offre de Devis bien supprimé`,
              icon: "UserIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Erreur lors de la suppression`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
          console.log(this.errorMessage);
        });
    },
    productQuote(data) {
      this.rowModal = data.products;
    },
    AddQuoteOffer(id) {
      var routerLink = `/shop/quote/edit-quote?id=${id}`;
      this.$router.replace(routerLink);
    },
    UpdateQuote(purchaseQuotation, purchaseOffer, props) {
      console.log(props);
      var routerLink = `/shop/quote/edit-quote?id=${purchaseQuotation}&purchaseOffer=${purchaseOffer}`;
      this.$router.replace(routerLink);
    },
    previewQuote(id) {
      var routerLink = "/shop/quote/preview-quote?id=" + id;
      this.$router.replace(routerLink);
    },
    createCommand(data) {
      this.$swal({
        title: "vous voulez vraiment créer une commande ?",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Confirmer !",
        cancelButtonText: "Annuler !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          var productsToSend = [];
          data.products.forEach((element) => {
            productsToSend.push({
              description: element.description,
              discount: element.discount,
              product: element.product._id,
              quantity: element.quantity,
              quantityType: element.quantityType,
              valueAddedTax: element.valueAddedTax,
            });
          });
          var payload = {
            code: data.code,
            createdBy: JSON.parse(localStorage.getItem("userData"))._id,
            allTaxesIncluded: data.allTaxesIncluded,
            priceWithoutTaxes: data.priceWithoutTaxes,
            supplier: data.supplier._id,
            deliveryDate: data.deliveryDate,
            description: data.description,
            priceWithoutTaxes: data.priceWithoutTaxes,
            products: productsToSend,
            stampPrice: data.stampPrice,
            totalDiscount: data.totalDiscount,
            valueAddedTax: data.valueAddedTax,
            warehouse: data.warehouse,
            salesBills: data._id,
            currency: data.currency,
          };

          console.log(payload);
          axios
            .post(
              "https://management-projects.herokuapp.com/api/purchase-commands",
              payload
            )
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Commande bien ajoutée`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Erreur lors de l'ajout`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
              console.log(this.errorMessage);
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action annulée",
            icon: "error",
            confirmButtonText: "Fermer !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    createInvoice(data) {
      this.$swal({
        title: "vous voulez vraiment créer une facture ?",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Confirmer !",
        cancelButtonText: "Annuler !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          var productsToSend = [];
          data.products.forEach((element) => {
            productsToSend.push({
              description: element.description,
              discount: element.discount,
              product: element.product._id,
              quantity: element.quantity,
              quantityType: element.quantityType,
              valueAddedTax: element.valueAddedTax,
            });
          });
          var payload = {
            code: data.code,
            createdBy: JSON.parse(localStorage.getItem("userData"))._id,
            allTaxesIncluded: data.allTaxesIncluded,
            priceWithoutTaxes: data.priceWithoutTaxes,
            supplier: data.supplier._id,
            deliveryDate: data.deliveryDate,
            description: data.description,
            priceWithoutTaxes: data.priceWithoutTaxes,
            products: productsToSend,
            stampPrice: data.stampPrice,
            totalDiscount: data.totalDiscount,
            valueAddedTax: data.valueAddedTax,
            warehouse: data.warehouse,
            salesBills: data._id,
            currency: data.currency,
          };

          console.log(payload);
          axios
            .post(
              "https://management-projects.herokuapp.com/api/sales-bills",
              payload
            )
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `facture bien ajoutée`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Erreur lors de l'ajout`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
              console.log(this.errorMessage);
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action annulée",
            icon: "error",
            confirmButtonText: "Fermer !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-wizard.scss";


</style>
<style>
.btn-action-table button {
  margin-left: 10px;
  margin-top: 5px;
}
.btn-action-table {
  display: flex;
}
.btn-delete-all {
  margin-left: 3%;
}

.p-description {
  height: 60px;
  width: 250px;
  overflow: auto;
}
.barcode-size svg {
  height: 80px;
}
.btn-table-groupe {
  float: right;
}
</style>
